import { render, staticRenderFns } from "./parleySetup.vue?vue&type=template&id=09006476&"
import script from "./parleySetup.vue?vue&type=script&lang=js&"
export * from "./parleySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports